module.exports = __webpack_public_path__ + "img/bell_2.652816c1.jpg";